import * as SupplierService from '../../../services/supplier.service';
import * as SupplierSuggestion from '../../../services/supplierSuggestion.service';
import * as SystemMaster from '../../../services/SystemMaster.services';
import * as Placeholder from '../../../services/placeholder.service';
import * as DevOrder from '../../../services/developmentOrder.service';

import * as POM from '../../../services/pom.services';
import * as colourLib from '../../../services/color-library.service';
import PlaceholderManagementType from './PlaceHolderManagement.type';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

export const fetchCategoriesAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params);
    if (res.code === 200 && res.data) {
      switch (params.categoryType) {
        case 1:
          await dispatch({
            type: PlaceholderManagementType.CATEGORY1,
            payload: res.data,
          });
          return res.data;

        case 2:
          await dispatch({
            type: PlaceholderManagementType.CATEGORY2,
            payload: res.data,
          });
          return res.data;

        default:
          return res.data;
      }
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllBrandAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllBrands(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.BRANDS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllSeasonsAction = (id) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSeasons(id);

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SEASONS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllDynamicField = () => async (dispatch) => {
  try {
    const res = await SystemMaster.getAllCustomAttribute();

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.DYNAMIC_COLUMN,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllProductType = (params) => async (dispatch) => {
  try {
    const res = await SystemMaster.getAllPCTypes(params);

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.PRODUCT_TYPE,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const savePlaceholderData = (params, transactionMsg) => async () => {
  try {
    const res = await Placeholder.postPlaceholderData(params);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PLACEHOLDER.${res.message}`);

      if (res.data?.errorList && res.data.errorList.length > 0) {
        toasterMsg(transactionMsg('BACKEND_SERVER.PLACEHOLDER_MANAGEMENT.PLACE_HOLDER_MANAGEMENT_SERVICE.COLUMN_SHOULD_UNIQUE'), 'danger');
      } else {
        toasterMsg(msg, 'success');
      }
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getPlaceholderData = (params) => async (dispatch) => {
  try {
    const res = await Placeholder.getPlaceholderData(params);

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.PLACEHOLDER_DATA,
        payload: res.data,
      });
      return res.data;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: PlaceholderManagementType.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deletePlaceholderData = (params, transactionMsg) => async () => {
  try {
    const res = await Placeholder.deletePlaceholder(params);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateQty = (params, transactionMsg) => async () => {
  try {
    const res = await Placeholder.updateQty(params);
    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if ([400].includes(res.code) && res?.data) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    if ([500].includes(res.code) && res?.data) {
      const msg = transactionMsg(`${res?.data?.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllSupplierTypeAction = (params) => async (dispatch) => {
  try {
    const res = await SystemMaster.getAllPCTypes(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SUPPLIERTYPE,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchPlaceholderProduct = (params) => async () => {
  try {
    const res = await Placeholder.getPlaceholderProduct(params);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const savePlaceholderProductAction = (params) => async () => {
  try {
    const res = await Placeholder.postPlaceholderProductData(params);
    if (res.code === 200 && res.data) {
      toasterMsg('Products updated successfully.', 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllLength = (data) => async (dispatch) => {
  try {
    const res = await SystemMaster.getAllLengths(data);

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllColour = (data) => async (dispatch) => {
  try {
    const res = await colourLib.getColorLibrary(data);

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllProductStatus = (data) => async (dispatch) => {
  try {
    const res = await SystemMaster.getAllProductStatus(data);

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllGrading = (data) => async (dispatch) => {
  try {
    const res = await POM.getGrading(data);

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCustomAttribute = (data) => async (dispatch) => {
  try {
    const res = await SystemMaster.getAllCustomAttribute(data);

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSupplier = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSupplier(data);

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateProduct = (id, data) => async (dispatch) => {
  try {
    const res = await DevOrder.updateDevOrder(id, data);

    if (res.code === 200 && res.data) {
      toasterMsg('Product updated successfully.', 'success');
      return res.code;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getOtherProductTags = () => async () => {
  try {
    const res = await DevOrder.getProductTags();
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getProductEditRules = (id) => async () => {
  try {
    const res = await DevOrder.getDevOrderEditRules(id);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const postProductChangeGrading = (id) => async () => {
  try {
    const res = await DevOrder.changeGrading(id);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveDraftholderProductAction = (params) => async () => {
  try {
    const res = await Placeholder.saveDraftData(params);
    if (res.code === 200 && res.data) {
      toasterMsg('Saved successfully.', 'success');
      return res;
    }
    if (res.code === 500) {
      toasterMsg('Please fill required fields', 'danger');
    }
  } catch (err) {
    console.log('errrrrrrrr', err);
    toasterMsg(err.toString(), 'danger');
  }
};
export const getSearchedProductList = (value) => async (dispatch) => {
  try {
    const res = await Placeholder.getSearchedProductListService(value);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SEARCHED_PRODUCTS,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const publishPlaceholderAction = (params) => async () => {
  try {
    const res = await Placeholder.publishPlacheholderManagement(params);
    if (res.code === 200 && res.data) {
      toasterMsg('Published successfully.', 'success');
      return res;
    }
    if (res.code === 400 && res.data) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const replacePlaceholderAction = (params, t) => async (dispatch) => {
  try {
    const res = await Placeholder.replacePlaceholderSevice(params);
    if (res.code === 200) {
      await dispatch({
        type: PlaceholderManagementType.SEARCHED_PRODUCTS,
        payload: [],
      });
      toasterMsg(t(res?.message), 'success');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: PlaceholderManagementType.CLEAR_REDUCER,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addPlaceholderCard = (params, t) => async () => {
  try {
    const res = await Placeholder.addPlaceholderCard(params);
    if (res.code === 200) {
      const msg = t(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getIndividualDetails = (id) => async (dispatch) => {
  try {
    const res = await Placeholder.getIndividualDetails(id);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SET_INDIVIDUAL_DETAILS,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getPlaceholderCardData = (params) => async (dispatch) => {
  try {
    const res = await Placeholder.getPlaceholderCardData(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.GET_PLACEHOLDER_CARD_DATA,
        payload: res.data,
      });
      return true;
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return false;
  }
};

export const deletePlaceholderCardData = (params, t) => async (dispatch) => {
  try {
    const res = await Placeholder.deletePlaceholderCardData(params);
    if (res.code === 200 && res.data) {
      const msg = t(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return false;
  }
};

export const clearIndividualReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: PlaceholderManagementType.CLEAR_INDIVIDUAL_REDUCER,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const archivePlaceholderCardData = (params, t) => async () => {
  try {
    const res = await Placeholder.archivePlaceholderCardData(params);
    if (res.code === 200 && res.data) {
      const msg = t(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return false;
  }
};
